import { render, staticRenderFns } from "./CockpitPromotor.vue?vue&type=template&id=8946685e&scoped=true"
import script from "./CockpitPromotor.vue?vue&type=script&lang=js"
export * from "./CockpitPromotor.vue?vue&type=script&lang=js"
import style0 from "./CockpitPromotor.vue?vue&type=style&index=0&id=8946685e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8946685e",
  null
  
)

export default component.exports